var render = function render(){var _vm=this,_c=_vm._self._c;return _c('my-window',{ref:"iframeWindow",attrs:{"title":_vm.tittle,"width":_vm.width,"height":_vm.height,"top":_vm.top,"left":_vm.left,"camera":false,"actions":_vm.actions,"onClose":_vm.onClose}},[_c('div',{staticClass:"camdiv"},[_c('embed',{staticClass:"camdiv",attrs:{"title":_vm.tittle,"src":_vm.url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }